<template>
	<v-btn
		:class="customClasses()"
		:color="customOrDefaultColor()"
		@click="add"
		large
		block
		depressed
	>
		ADICIONAR
	</v-btn>
</template>

<script>
export default {
	name: 'ListAddButton',
	components: {},
	props: {
		buttonClass: String,
		color: String,
	},
	methods: {
		add() {
			this.$emit('add');
			this.$emit('click');
		},
		customOrDefaultColor() {
			return this.color || 'primary';
		},
		customClasses() {
			return this.buttonClass || '';
		},
	},
};
</script>

<style>

</style>
